import { makeAutoObservable, action, observable } from "mobx";

export class AlertModalController {
  isVisible = false;
  message = "";

  constructor() {
    makeAutoObservable(this, {
      isVisible: observable,
      message: observable,
      showMessage: action,
      hideMessage: action,
    });
  }

  showMessage(message) {
    this.message = message;
    this.isVisible = true;
  }

  hideMessage() {
    this.message = "";
    this.isVisible = false;
  }

  get getMessage() {
    return this.message;
  }

  get getIsVisible() {
    return this.isVisible;
  }
}

export default AlertModalController;
